import "./index.scss"
import "@/i18n"

import localForage from "localforage"
import { StrictMode } from "react"
import { render } from "react-dom"

import { showAppUpdateToast } from "@/components/Toast"
import { initSentry, SentryErrorBoundary } from "@/sentry"

import { App } from "./App"
import { register as registerServiceWorker } from "./registerServiceWorker"

initSentry()

localForage.config({
  name: "deligoo-support",
})

render(
  <StrictMode>
    <SentryErrorBoundary>
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
  document.getElementById("root")
)

export function invokeSWUpdateFlow(registration: ServiceWorkerRegistration) {
  const waitingServiceWorker = registration.waiting
  if (!waitingServiceWorker) return

  const skipWaiting = () => {
    waitingServiceWorker.postMessage({ type: "SKIP_WAITING" })
  }

  showAppUpdateToast(skipWaiting)
}

function checkForWaitingSW() {
  navigator.serviceWorker.getRegistration().then((registration) => {
    if (registration?.waiting) invokeSWUpdateFlow(registration)
  })
}

if ("serviceWorker" in navigator) {
  let isRefreshing = false

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!isRefreshing) {
      window.location.reload()
      isRefreshing = true
    }
  })

  checkForWaitingSW()

  const WAITING_CHECK_INTERVAL = 15 * 60 * 1000
  setInterval(checkForWaitingSW, WAITING_CHECK_INTERVAL)
}

registerServiceWorker({
  onUpdate: (registration) => {
    if (registration.waiting) invokeSWUpdateFlow(registration)
  },
})
